<template>
  <common-dialog :border="border" :close-on-click-modal="false" :visible="dialog.isShow" class="spec-dialog"
              @close="handleCloseDialog" width="40%">
    <div  slot="title">
      <template v-if="Object.is(dialog.dialogType,dialogType.add)">新增大喇叭文章信息</template>
      <template v-if="Object.is(dialog.dialogType,dialogType.view)">
        <span class="title">{{ dialog.form.postTitle }}</span></template>
      <template v-if="Object.is(dialog.dialogType,dialogType.update)">编辑大喇叭文章信息</template>
    </div>
    <div>
      <el-form label-width="100px" v-loading="dialog.isLoading" :rules="rules" ref="ruleForm" :model="dialog.form">

        <el-form-item v-else  label="标题" prop="postTitle" v-if="!Object.is(dialogType.view, dialog.dialogType)">
          <el-input v-model="dialog.form.postTitle" type="text" placeholder="请输入" clearable>
          </el-input>
        </el-form-item>


        <div style="text-align: right !important; padding-bottom: 10px; font-size: 13px">
          <span v-if="Object.is(dialogType.view, dialog.dialogType)"  >
                          发布人：{{dialog.form.userName}}
          </span>
        </div>

        <div style="text-align: right !important; color: rgb(153, 153, 153);font-size: 13px;margin-right: 6px">
          <span v-if="Object.is(dialogType.view, dialog.dialogType)" >
                          {{dialog.form.createTm|dateFormat}}
          </span>
        </div>

        <div v-if="Object.is(dialogType.view, dialog.dialogType)" class="dialog-body">
          &nbsp; {{dialog.form.postContent}}

        </div>


        <el-form-item v-else  label="内容" prop="postContent" >
          <el-input v-model="dialog.form.postContent" type="textarea" placeholder="请输入" :maxlength="1000" :rows="10"clearable>
          </el-input>
        </el-form-item>



      </el-form>

    </div>

    <template slot="footer" >
      <common-button @click="handleCommitDialog"   type="primary" v-show="editFlag!= 'view'" style="margin-left: 15px">保存</common-button>
      <common-button @click="handleCloseDialog" type="cancel">取消</common-button>
    </template>
    <animation :loadingDataVisible="!attachmentUploadState || !formInfoSaveState" :loadingText="loadingText"></animation>
  </common-dialog>
</template>

<script>
  import * as constantsRules from '@/constants/constantRules'
  import http from "@/utils/axios";
  import cookie from "@/utils/cookie";
  import {mapState} from "vuex";
  import {Message} from "element-ui";
  import {DIALOG_TYPE_ADD,DIALOG_TYPE_VIEW,DIALOG_TYPE_UPDATE} from '@/constants/constants'
  import animation from '@/components/loading/animation'

    export default {
        name: "LoudSpeakerDetail",
      components:{animation},
      props: {
        //表示是否操作标识类型 view add update
        editFlag :{
          type:String,
          default: "view",
        },
        dlbId: {
          type: String,
          default: null
        },
        border:{
          type: Boolean,
        }
      },
      data(){
          return{
            this_:this,
            //true是结束,false是正在处理
            attachmentUploadState:true,
            //true是结束,false是正在处理
            formInfoSaveState:true,
            //附件的允许上传的类型
            rules: constantsRules.LoudSpeakerRules,
            dialogType: {
              add: DIALOG_TYPE_ADD,
              view: DIALOG_TYPE_VIEW,
              update: DIALOG_TYPE_UPDATE
            },
            dialog:{
              dialogType: null,
              editedFlag: false,
              isShow: false,
              isLoading: false,
              //附件上传框 是否可见
              // opt:false,
              form: {
                id:'',
                postTitle: '',
                postContent: '',
                createUserId:'',
                create_tm:'',
                userId:'',
                userName:'',
                // //附加列表
                // attachIds: [],
              },
            },
              loadingText:'',
            commitFlag:'0'

          }
      },
      created(){
          // this.data.list=this.LoudSpeakerDetail
        this.dialog.isShow = true
        this.dialog.dialogType = this.editFlag=='add'?this.dialogType.add:this.dialogType.view;
        // this.dialog.opt = this.editFlag=='update'||  this.editFlag=='add'?true:(false);
        if (this.dlbId) {
          this.queryLoukSpeakerDetail();
        }

      },
      methods:{
        handleCloseDialog(){
          this.$refs['ruleForm'].resetFields();
          Object.assign(this.$data.dialog.form, this.$options.data().dialog.form);
          this.$emit('closeDialog',this.commitFlag)
        },
        validateDialogForm() {
          let result = false;
          this.$refs['ruleForm'].validate((valid) => {
            if (valid) {
              result = true;
            }
          });
          return result;
        },
        handleCommitDialog(){
          if(!this.validateDialogForm()){
            return false
          }
          this.loadingText="保存中"
          this.saveLoudSpeaker();
          },
        //保存数据
        saveLoudSpeaker(){
          let obj={
            token:cookie.getCookie("token"),
            data:{
              "userId": this.dialog.form.userId,
              "title":this.dialog.form.postTitle,
              "content":this.dialog.form.postContent,
            }

          }
          http.post(window.config.api.baseUrl + '/eims-api/loudSpeaker/create', obj).then(response =>{
            if (response.data.code === '00000'){
              if(Object.is(this.dialogType.add, this.dialog.dialogType)){
                Message.success("大喇叭文章信息新增成功")
            }else {
                Message.success("大喇叭文章信息新增失败")
              }
            }
            }).finally(()=>{
            this.dialog.isShow = false;



          })

        },
        queryLoukSpeakerDetail(){
          let _this = this;
          this.dialog.isLoading = true;
          http.post(window.config.api.baseUrl + '/eims-api/loudSpeaker/detail', {
            token: cookie.getCookie("token"),
            data: {
              dlbId: _this.dlbId,
            }
          }).then((response) =>{
            let data =  response.data.data;
            this.dialog.form=data.loudSpeaker;
          }).finally(() => {
            _this.dialog.isLoading = false;
          });

        },

      }
    }
</script>

<style scoped>


  .title{
    width: 60%;
    display: inline-block;
  }

  .dialog-body{
  margin-top: 6px;
    height: 280px;
    overflow-y: scroll;
    overflow-x:hidden;
    /*将溢出的文本使用...显示*/
    text-overflow:ellipsis;
    text-indent: 2em;
  }
  /deep/ .el-dialog__body{
    line-height: 1.9!important;
  }



  /deep/ .el-image__error{
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/detail/LoudSpeakerDetail.vue